import { LoadingScreen } from '../components/LoadingScreen';

export function LoadingPage() {
  return <LoadingScreen />;
}
